import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
:root {
    --input-placeholder-color: #FFFFFF99;

    &, &.light-mode {
      --color-primary: #72ABB4;
      --color-secondary: #0C798B;
      --color-text-secondary: #000;
      --color-background: #FFFFFF;
      --color-text: #FFFFFF;
      --color-border: #dcdcdc;

      --icon-color: #FFFFFF;
      --icon-color-secondary: #000000;
      --icon-color-hover: #0A3547CC;

      --scrollbar-hover: #0A3547CC;

      --use-case-primary: #72ABB4;
      --use-case-secondary: #0C798B;
      --use-case-tertiary: #175066;
      --use-case-text: #000;
      --use-case-background: transparent;
      --ask-color: #FFFFFF;

      --chat-color: #000;

      --color-active: #72abb4;
      --color-active-text: #fff;

      --navigation: #fff;

      --chip-bg: rgba(114, 171, 180, 0.22);
      --chip-text: #175066;

      --donut-1: #175066;
      --donut-2: #0C798B;
      --donut-3: #72ABB4;
      --donut-4: #9CAEB1;

      --deployment-card-bg: rgba(114, 171, 180, 0.10);
    }

    &.classic-mode {
      --color-primary: #0A3547;
      --color-secondary: #fff;
      --color-text-secondary: #fff;
      --color-background: #72ABB4;
      --color-text: #0C798B;
      --color-border: #0C798B;

      --icon-color: #0C798B;
      --icon-color-secondary: #FFF;
      --icon-color-hover: #72ABB4CC;

      --scrollbar-hover: #0A3547CC;

      --use-case-primary: #A3D3E3;
      --use-case-secondary: #0C798B;
      --use-case-tertiary: #175066;
      --use-case-text: #000;
      --use-case-background: #FFF;
      --ask-color: #FFFFFF;

      --chat-color: #FFF;

      --color-active: #0A3547;
      --color-active-text: #fff;

      --navigation: #fff;

      --chip-bg: rgba(255, 255, 255, 0.2);
      --chip-text: #FFF;

      --donut-1: #175066;
      --donut-2: #0C798B;
      --donut-3: #FFFFFF;
      --donut-4: #9CAEB1;

      --deployment-card-bg: rgba(255, 255, 255, 0.10);
    }

    &.dark-mode {
      --color-primary: #282A2C;
      --color-secondary: #FFF;
      --color-text-secondary: #fff;
      --color-background: #1E1F20;
      --color-text: #FFFFFF;
      --color-border: #FFF;

      --icon-color: #FFFFFF;
      --icon-color-secondary: #FFFFFF;
      --icon-color-hover: #DCDCDCCC;

      --scrollbar-hover: #000000CC;

      --use-case-primary: #FFF;
      --use-case-secondary: #FFFFFFB3;
      --use-case-tertiary: #FFFFFF66;
      --use-case-text: #FFF;
      --use-case-background: transparent;
      --ask-color: #000;

      --chat-color: #FFF;

      --color-active: #fff;
      --color-active-text: #000;

      --navigation: #fff;

      --chip-bg: rgba(114, 171, 180, 0.18);
      --chip-text: #FFF;

      --donut-1: #175066;
      --donut-2: #0C798B;
      --donut-3: #72ABB4;
      --donut-4: #9CAEB1;

      --deployment-card-bg: rgba(114, 171, 180, 0.10);
    }
}

*,
*::before,
*::after {
  box-sizing: border-box;
  padding: 0;
  margin: 0;

  /* Creating animations for dark mode */
  transition: background-color 0.3s, border 0.3s;
}

body {
    transition: color 0.3s, background-color 0.3s;
    min-height: 100%;
    height: 100dvh;
    position: relative;
}

input,
button,
textarea,
select {
  font: inherit;
  color: inherit;
}

button {
  cursor: pointer;
}

*:disabled {
  cursor: not-allowed;
}

button:has(svg) {
  line-height: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

ul {
  list-style: none;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
  hyphens: auto;
}

img {
  max-width: 100%;

  /* For dark mode */
  // filter: grayscale(var(--image-grayscale)) opacity(var(--image-opacity));
}

::-webkit-scrollbar {
    width: 8px; /* Largura da barra de rolagem */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* Cor do fundo da barra */
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-hover);
  }

  /* scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1; */
`;

export default GlobalStyles;
